import AddMessage from "../../add-message/AddMessage";

const SectionNotification = () => {
  return <AddMessage />;
};

export default SectionNotification;
